import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    storage: window.sessionStorage
});

export default new Vuex.Store({
    state: {
        defaultYear: 1 * process.env.MIX_DEFAULT_YEAR,
        updatedAt: moment(process.env.MIX_UPDATED_AT).toDate()
    },
    mutations: {
        setDefaultYear(state, payload) {
            state.defaultYear = payload;
        }
    },
    plugins: [vuexLocal.plugin]
});



// WEBPACK FOOTER //
// ./resources/assets/js/Store/store.js